import { render } from "./DDDocumentTab.vue?vue&type=template&id=7ec4381c"
import script from "./DDDocumentTab.vue?vue&type=script&lang=js"
export * from "./DDDocumentTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__